export default __webpack_public_path__ + "static/media/logo.5fabc12c.svg";